import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { FormattedMessage } from 'ui/i18n';
import { COUNTRIES, CUSTOMER_PHONE_NUMBER } from 'config/constants';

import './UnauthorizedMessage.scss';

@inject('AppState')
export default class UnauthorizedMessage extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
	};

	render() {
		const countryName = this.props.AppState.user
			? this.props.AppState.user.country.long_name
			: COUNTRIES.US;

		const customerPhone = CUSTOMER_PHONE_NUMBER[countryName];
		return (
			<div className="UnauthorizedMessage">
				<h4>
					<FormattedMessage id="unauthorizedMessage.noPermissionsText" />
				</h4>
				<p>
					<FormattedMessage id="unauthorizedMessage.noPermissionsText2" />
				</p>
				<p>
					<FormattedMessage
						id="unauthorizedMessage.nationalCareCenterMessage"
						values={{ customerPhone }}
					/>
				</p>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/UnauthorizedMessage/index.js